import { useTranslation } from "react-i18next";

const items = [
  { key: 1, icon: "ri-music-2-line" },
  { key: 2, icon: "ri-computer-line" },
  { key: 3, icon: "ri-sound-module-line" },
  { key: 4, icon: "ri-settings-3-line" },
];

export default function Curriculum() {
  const { t } = useTranslation();

  return (
    <section id="curriculum" className="relative bg-midnight py-24 md:py-36">
      <div className="w-full px-6 md:px-12 lg:px-16">
        {/* Header */}
        <div className="text-center mb-16 md:mb-24">
          <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-6">
            {t("curriculum.tag")}
          </span>
          <h2 className="text-marble font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-wide">
            {t("curriculum.title")}
          </h2>
          <p className="mt-4 text-warmgray text-sm md:text-base font-sans">
            {t("curriculum.subtitle")}
          </p>
        </div>

        {/* Curriculum Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item) => (
            <div
              key={item.key}
              className={`group relative rounded-xl p-6 md:p-8 border transition-all duration-500 cursor-default ${
                item.key === 4
                  ? "bg-champagne/10 border-champagne/40 ring-1 ring-champagne/20"
                  : "bg-charcoal/40 border-white/5 hover:bg-champagne"
              }`}
            >
              {item.key === 4 && (
                <div className="absolute -top-3 right-6 bg-champagne text-deepblack text-[10px] font-sans tracking-widest uppercase px-3 py-1 rounded-full">
                  {t("pricing.equipment.badge")}
                </div>
              )}
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-6 transition-colors duration-500 ${
                item.key === 4
                  ? "bg-champagne/20 group-hover:bg-champagne/30"
                  : "bg-deepblack/60 group-hover:bg-deepblack/20"
              }`}>
                <i className={`${item.icon} text-lg transition-colors duration-500 ${
                  item.key === 4
                    ? "text-champagne"
                    : "text-marble/70 group-hover:text-deepblack"
                }`} />
              </div>
              <h3 className={`font-serif text-lg md:text-xl font-medium tracking-wide mb-3 transition-colors duration-500 ${
                item.key === 4
                  ? "text-champagne"
                  : "text-marble group-hover:text-deepblack"
              }`}>
                {t(`curriculum.item${item.key}.title`)}
              </h3>
              <p className={`text-sm font-sans leading-relaxed whitespace-pre-line transition-colors duration-500 ${
                item.key === 4
                  ? "text-marble/70"
                  : "text-warmgray group-hover:text-deepblack/70"
              }`}>
                {t(`curriculum.item${item.key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}